import AboutUs from './AboutUs'

export default AboutUs
